import React, { useEffect, useMemo, memo } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import { getUserProjectList } from "@/redux/actions/projectAction"
import { setArchiveFilterCount } from "@/redux/actions//archiveFilterAction"
import { useSelector, useDispatch } from "react-redux"
import Button from "@material-ui/core/Button"
import Loading from "@/components/common/Loading"
import { resetActivateProcess } from "@/redux/actions/activateProjectProcessAction"
import modalStatusHandler from "@/redux/actions/modalAction"
import ProjectDashboardContentBlock from "./ProjectDashboardContentBlock"
import { Grid, Typography } from "@material-ui/core"
import clsx from "clsx"
import { setCurrentArchiveFilter } from "@/redux/actions/archiveFilterAction"

const useStyles = makeStyles((theme) => ({
    errorMsgWrapper: {
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(4),
    },
    projectDetailWrapper: {
        "& .project-block[data-status=archive]": { 
            // .archive-true
            display: ({ filterValue }) => {
                return filterValue === "archive" || filterValue === "all" ? "inline-block" : "none"
            },
        },
        "& .project-block[data-status=unarchive]": {
            // archive-false
            display: ({ filterValue }) => {
                return filterValue === "unarchive" || filterValue === "all" ? "inline-block" : "none"
            },
        },
        "& .project-block[data-status=completed]": {
            // completed-true
            display: ({ filterValue }) => {
                return filterValue === "completed" || filterValue === "all" ? "inline-block" : "none"
            },
        },
    },
}))

const ProjectDashboardContentBody = memo(() => {
    const archiveFilterData = useSelector((state) => state.archiveFilterReducer)
    const styleProps = {
        filterValue: archiveFilterData.currentFilter,
    }
    const classes = useStyles(styleProps)
    const dispatch = useDispatch()
    const userData = useSelector((state) => state.userReducer)
    const { loading, searched: projects, message: projectSuccessMessage, successStatus } = useSelector((state) => state.projectReducer)
    const { user } = userData // signed up user

    useEffect(() => {
        const retrieveProjectList = () => {
            if (user && user.userId) {
                dispatch(getUserProjectList(user.userId))
            }
        }
        retrieveProjectList()
        dispatch(setCurrentArchiveFilter("all"))
    }, [user.userId])

    const handleAddProject = () => {
        dispatch(
            modalStatusHandler({
                modalProjectId: null,
                currentStep: 1,
                modalShow: true,
            })
        )
        dispatch(resetActivateProcess)
    }

    const AddNewProjectButton = (
        <Box p={"16px"} display="flex" flexDirection={"column"} gridRowGap="32px">
            <Typography>No projects found...</Typography>
            <Button variant="contained" color="primary" onClick={handleAddProject}>
                + Start First Project
            </Button>
        </Box>
    )

    const getProjectStatus = (project) => {
        if(project.projectLaunchDate){
            return "completed"
        }
        else if(project.projectArchive){
            return "archive"
        }else{
            return "unarchive"
        }        
    }


    const renderOutput = useMemo(() => {
        const outputArray = []
        let filterAllCount = 0
        let filterArchiveCount = 0
        let filterUnArchiveCount = 0
        let filterCompletedCount = 0;
        let outputNew = ""
        if (projectSuccessMessage !== "") {
            if (!projects || !projects.length) {
                outputNew = AddNewProjectButton
            } else {
                // check if participant project only
                let participantRoleOnlyCount = 0
                projects.forEach((projectDetail) => {
                    if (projectDetail.userRole && projectDetail.userRole.length === 1 && projectDetail.userRole[0].userRoleId === 4) {
                        // participant role only
                        participantRoleOnlyCount++
                    } else {
                        filterAllCount++
                        if (projectDetail.projectArchive) {
                            filterArchiveCount++
                        } 
                        if(!projectDetail.projectArchive) {
                            filterUnArchiveCount++
                        }
                        if(projectDetail.projectLaunchDate){
                            filterCompletedCount++;
                        }
                        outputArray.push(<Grid className={clsx("project-block")} id={`project-${projectDetail.projectId}`}
                        data-status={getProjectStatus(projectDetail)} item xs={12} sm={12} md={6} lg={4} xl={3}>
                            <ProjectDashboardContentBlock key={projectDetail.projectId} projectDetail={projectDetail} />
                        </Grid>)
                    }
                })
                if (projects.length === participantRoleOnlyCount) outputNew = AddNewProjectButton
                dispatch(
                    setArchiveFilterCount({
                        all: filterAllCount,
                        archive: filterArchiveCount,
                        unarchive: filterUnArchiveCount,
                        completed: filterCompletedCount
                    })
                )
            }
        }
        return outputNew || outputArray
    }, [user.userId, projects, projectSuccessMessage])

    return (
        <Box component="div" fontSize="fontSize" fontFamily="fontFamily" display="flex" flexWrap="wrap">
            {loading ? (
                <Loading content="Loading Projects..." transformX={50} />
            ) : (
                <>
                    {successStatus ? (
                        <>
                            <Grid auto="true" spacing={4} container wrap="wrap" className={classes.projectDetailWrapper}>
                                {renderOutput}
                            </Grid>
                        </>
                    ) : (
                        <Box className={`${classes.errorMsgWrapper}`}>Cannot retrieve project detail</Box>
                    )}
                </>
            )}
        </Box>
    )
})

export default ProjectDashboardContentBody
